import { useAppState } from "./stateHooks";
import { useClaService } from "./useClaService";

export const useMessageStatus = (chatId: string, messageId: string) => {
  const claService = useClaService();
  return useAppState(
    claService,
    () =>
      claService
        .getState()
        .chats.find((chat) => chat.id === chatId)
        ?.messages.find((msg) => msg.id === messageId)?.status,
  );
};
